import environment from "environment";
import HttpErrorResponseModel from "../../models/HttpErrorResponseModel";
import HttpUtility from "../../utilities/HttpUtility";
import { AxiosResponse } from "axios";
import EffectUtility from "../../utilities/EffectUtility";
import RichiestaModel from "./models/RichiestaModel";
import ResponseEsitoModel from "stores/shared/models/ResponseEsitoModel";
import RichiestaDatiAnagraficiRequestModel from "./models/RichiestaDatiAnagraficiRequestModel";
import RichiestaDatiRedditoRequestModel from "./models/RichiestaDatiRedditoRequestModel";
import RichiestaAltriPrestitiRequestModel from "./models/RichiestaAltriPrestitiRequestModel";
import RichiestaDocumentoViewModel from "./models/RichiestaDocumentoViewModel";
import RichiestaDocumentoRequestModel from "./models/RichiestaDocumentoRequestModel";
import ResponseStatoModel from "../shared/models/ResponseStatoModel";
import CqsOnlineRichiestaSezioneDocumentiViewModel from "stores/cqsonline/models/CqsOnlineRichiestaSezioneDocumentiViewModel";
import CqsOnlineRichiestaUploadDocumentoRequestModel from "stores/cqsonline/models/CqsOnlineRichiestaUploadDocumentoRequestModel";
import RichiestaConcludiRequestModel from "./models/RichiestaConcludiRequestModel";
import NuovoImpegnoModel from "stores/preventivo/models/NuovoImpegnoModel";
import RichiestaAdeguataVerificaRequestModel from "./models/RichiestaAdeguataVerificaRequestModel";
import moment from "moment";

export default class RichiestaEffect {
    public static async verificaRichiesta(): Promise<ResponseEsitoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.verificaRichiesta;
        return EffectUtility.getToModel<ResponseEsitoModel>(ResponseEsitoModel, endpoint);
    }

    public static async requestRichiesta(idRichiesta: number): Promise<RichiestaModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.getRichiesta;
        return EffectUtility.postToModel<RichiestaModel>(RichiestaModel, endpoint, {
            idRichiesta: idRichiesta,
        });
    }

    public static async saveStepRichiesta(
        idRichiesta: number,
        isSospensione: boolean,
        step: string
    ): Promise<ResponseEsitoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.saveStepRichiesta;
        return EffectUtility.postToModel<ResponseEsitoModel>(ResponseEsitoModel, endpoint, {
            idRichiesta: idRichiesta,
            isSospensione: isSospensione,
            step: step,
        });
    }

    public static async downloadPianoAmmortamento(
        idPreventivo: number,
        progressHandler: (progress: number) => void
    ): Promise<Blob | HttpErrorResponseModel> {
        const endpoint: string = environment.api.getDocumentoPianoAmmortamento + "/" + idPreventivo.toString();
        return EffectUtility.getFile(endpoint, undefined, progressHandler);
    }

    public static async requestDatiAnagrafici(
        codTipoRichiedente: string
    ): Promise<RichiestaDatiAnagraficiRequestModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.getDatiAnagrafici;
        return EffectUtility.getToModel<RichiestaDatiAnagraficiRequestModel>(
            RichiestaDatiAnagraficiRequestModel,
            endpoint,
            { codTipoRichiedente: codTipoRichiedente }
        );
    }

    public static async saveDatiAnagrafici(
        request: RichiestaDatiAnagraficiRequestModel
    ): Promise<ResponseEsitoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.saveDatiAnagrafici;
        return EffectUtility.postToModel<ResponseEsitoModel>(ResponseEsitoModel, endpoint, request);
    }

    public static async requestDatiReddito(
        codTipoRichiedente: string
    ): Promise<RichiestaDatiRedditoRequestModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.getDatiReddito;
        return EffectUtility.getToModel<RichiestaDatiRedditoRequestModel>(RichiestaDatiRedditoRequestModel, endpoint, {
            codTipoRichiedente: codTipoRichiedente,
        });
    }

    public static async saveDatiReddito(
        request: RichiestaDatiRedditoRequestModel
    ): Promise<ResponseEsitoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.saveDatiReddito;
        return EffectUtility.postToModel<ResponseEsitoModel>(ResponseEsitoModel, endpoint, request);
    }

    public static async requestAltriPrestiti(
        codTipoRichiedente: string
    ): Promise<RichiestaAltriPrestitiRequestModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.getAltriPrestiti;
        return EffectUtility.getToModel<RichiestaAltriPrestitiRequestModel>(
            RichiestaAltriPrestitiRequestModel,
            endpoint,
            { codTipoRichiedente: codTipoRichiedente }
        );
    }

    public static async saveAltriPrestiti(
        request: RichiestaAltriPrestitiRequestModel
    ): Promise<ResponseEsitoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.saveAltriPrestiti;
        return EffectUtility.postToModel<ResponseEsitoModel>(ResponseEsitoModel, endpoint, request);
    }

    public static async requestDocumenti(
        codTipoRichiedente: string,
        codSezione: string
    ): Promise<RichiestaDocumentoViewModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.getDocumenti;
        return EffectUtility.getToModel<RichiestaDocumentoViewModel[]>(RichiestaDocumentoViewModel, endpoint, {
            codTipoRichiedente: codTipoRichiedente,
            codSezione: codSezione,
        });
    }

    public static async uploadDocumento(
        request: RichiestaDocumentoRequestModel,
        progressHandler: (progress: number) => void
    ): Promise<ResponseEsitoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.saveDocumento;
        return EffectUtility.postFormDataToModel<ResponseEsitoModel>(
            ResponseEsitoModel,
            endpoint,
            request,
            progressHandler
        );
    }

    public static async downloadDocumento(
        idDocumento: number,
        progressHandler: (progress: number) => void
    ): Promise<Blob | HttpErrorResponseModel> {
        const endpoint: string = environment.api.getDocumento + "/" + idDocumento.toString();
        return EffectUtility.getFile(endpoint, undefined, progressHandler);
    }

    public static async deleteDocumento(idDocumento: number): Promise<ResponseEsitoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.deleteDocumento + "/" + idDocumento.toString();
        return EffectUtility.deleteToModel<ResponseEsitoModel>(ResponseEsitoModel, endpoint);
    }

    public static async requestAvviaProcessoFirma(
        codTipoRichiedente: string,
        tipoProcesso: string
    ): Promise<ResponseEsitoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.avviaProcessoFirma;
        return EffectUtility.postToModel<ResponseEsitoModel>(ResponseEsitoModel, endpoint, {
            codTipoRichiedente: codTipoRichiedente,
            tipoProcesso: tipoProcesso,
        });
    }

    public static async requestAnnullaProcessoFirma(
        codTipoRichiedente: string,
        tipoProcesso: string
    ): Promise<ResponseEsitoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.annullaProcessoFirma;
        return EffectUtility.postToModel<ResponseEsitoModel>(ResponseEsitoModel, endpoint, {
            codTipoRichiedente: codTipoRichiedente,
            tipoProcesso: tipoProcesso,
        });
    }

    public static async requestStatoProcessoFirma(
        codTipoRichiedente: string,
        tipoProcesso: string
    ): Promise<ResponseStatoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.getStatoProcessoFirma;
        return EffectUtility.getToModel<ResponseStatoModel>(ResponseStatoModel, endpoint, {
            codTipoRichiedente: codTipoRichiedente,
            tipoProcesso: tipoProcesso,
        });
    }

    public static async requestAvviaProcessoRiconoscimento(
        codTipoRichiedente: string,
        tipoProcesso: string
    ): Promise<ResponseEsitoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.avviaProcessoRiconoscimento;
        return EffectUtility.postToModel<ResponseEsitoModel>(ResponseEsitoModel, endpoint, {
            codTipoRichiedente: codTipoRichiedente,
            tipoProcesso: tipoProcesso,
        });
    }

    /* public static async requestAnnullaProcessoRiconoscimento(
        codTipoRichiedente: string,
        tipoProcesso: string
    ): Promise<ResponseEsitoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.annullaProcessoRiconoscimento;
        return EffectUtility.postToModel<ResponseEsitoModel>(ResponseEsitoModel, endpoint, {
            codTipoRichiedente: codTipoRichiedente,
            tipoProcesso: tipoProcesso,
        });
    } */

    /*  public static async requestStatoProcessoRiconoscimento(
        codTipoRichiedente: string
    ): Promise<ResponseStatoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.getStatoProcessoRiconoscimento;
        return EffectUtility.getToModel<ResponseStatoModel>(ResponseStatoModel, endpoint, {
            codTipoRichiedente: codTipoRichiedente,
        });
    }
 */
    // #region CQS online
    public static async requestDocumentiDaCaricareCqsOnline(
        idPreventivo: number
    ): Promise<CqsOnlineRichiestaSezioneDocumentiViewModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.getDocumentiDaCaricareCQSonline;
        return EffectUtility.getToModel<CqsOnlineRichiestaSezioneDocumentiViewModel[]>(
            CqsOnlineRichiestaSezioneDocumentiViewModel,
            endpoint,
            { idPreventivo }
        );
    }

    public static async requestDocumentiDaFirmareCqsOnline(
        idPreventivo: number
    ): Promise<CqsOnlineRichiestaSezioneDocumentiViewModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.getDocumentiDaFirmareCQSonline;
        return EffectUtility.getToModel<CqsOnlineRichiestaSezioneDocumentiViewModel[]>(
            CqsOnlineRichiestaSezioneDocumentiViewModel,
            endpoint,
            { idPreventivo }
        );
    }

    public static async requestStatoFirmaCqsOnline(
        idPreventivo: number
    ): Promise<ResponseStatoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.statoFirmaCQSonline;
        return EffectUtility.getToModel<ResponseStatoModel>(ResponseStatoModel, endpoint, { idPreventivo });
    }

    public static async uploadDocumentoCqsOnline(
        request: CqsOnlineRichiestaUploadDocumentoRequestModel,
        progressHandler: (progress: number) => void
    ): Promise<ResponseEsitoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.saveDocumentoCQSonline;
        return EffectUtility.postFormDataToModel<ResponseEsitoModel>(
            ResponseEsitoModel,
            endpoint,
            request,
            progressHandler
        );
    }

    public static async saveSezioneDocumentiCqsOnline(
        idPreventivo: number,
        sezione: CqsOnlineRichiestaSezioneDocumentiViewModel
    ): Promise<ResponseEsitoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.saveSezioneDocumentiCQSonline;
        return EffectUtility.postToModel<ResponseEsitoModel>(ResponseEsitoModel, endpoint, { idPreventivo, sezione });
    }

    public static async downloadDocumentoCqsOnline(
        idDocumento: number,
        isFirmato: boolean = false,
        progressHandler: (progress: number) => void
    ): Promise<Blob | HttpErrorResponseModel> {
        const endpoint: string = environment.api.getDocumentoCQSonline;
        return EffectUtility.getFile(endpoint, { idDocumento, isFirmato }, progressHandler);
    }

    public static async deleteDocumentoCqsOnline(
        idDocumento: number
    ): Promise<ResponseEsitoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.deleteDocumentoCQSonline + "/" + idDocumento.toString();
        return EffectUtility.deleteToModel<ResponseEsitoModel>(ResponseEsitoModel, endpoint);
    }

    public static async requestAvviaProcessoFirmaCqsOnline(
        idPreventivo: number,
        idGruppo: number
    ): Promise<ResponseEsitoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.avvioFirmaCQSonline;
        return EffectUtility.postToModel<ResponseEsitoModel>(ResponseEsitoModel, endpoint, {
            idPreventivo: idPreventivo,
            idGruppo: idGruppo,
        });
    }

    public static async requestAnnullaProcessoFirmaCqsOnline(
        idPreventivo: number,
        idGruppo: number
    ): Promise<ResponseEsitoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.annullaFirmaCQSonline;
        return EffectUtility.postToModel<ResponseEsitoModel>(ResponseEsitoModel, endpoint, {
            idPreventivo: idPreventivo,
            idGruppo: idGruppo,
        });
    }

    public static async requestAvviaProcessoRiconoscimentoCqsOnline(
        idPreventivo: number
    ): Promise<ResponseEsitoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.avviaRiconoscimentoCQSonline;
        return EffectUtility.postToModel<ResponseEsitoModel>(ResponseEsitoModel, endpoint, {
            idPreventivo: idPreventivo,
        });
    }

    public static async requestAnnullaProcessoRiconoscimentoCqsOnline(
        idPreventivo: number
    ): Promise<ResponseEsitoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.annullaRiconoscimentoCQSonline;
        return EffectUtility.postToModel<ResponseEsitoModel>(ResponseEsitoModel, endpoint, {
            idPreventivo: idPreventivo,
        });
    }

    public static async requestStatoProcessoRiconoscimentoCqsOnline(
        idPreventivo: number
    ): Promise<ResponseStatoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.getStatoRiconoscimentoCQSonline;
        return EffectUtility.getToModel<ResponseStatoModel>(ResponseStatoModel, endpoint, {
            idPreventivo: idPreventivo,
        });
    }

    public static async requestCheckPreventivoCqsOnline(
        idPreventivo: number
    ): Promise<ResponseEsitoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.verificaPreventivo;
        return EffectUtility.getToModel<ResponseEsitoModel>(ResponseEsitoModel, endpoint, { idPreventivo });
    }

    public static async requestCancellaPreventivoRichiestaCqsOnline(
        idPreventivo: number
    ): Promise<ResponseEsitoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.cancellaPreventivoRichiesta;
        return EffectUtility.getToModel<ResponseEsitoModel>(ResponseEsitoModel, endpoint, { idPreventivo });
    }

    public static async requestDocumentiIstruttoriaDaFirmareCqsOnline(
        idPreventivo: number
    ): Promise<CqsOnlineRichiestaSezioneDocumentiViewModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.getDocumentiIstruttoriaDaFirmareCQSonline;
        return EffectUtility.getToModel<CqsOnlineRichiestaSezioneDocumentiViewModel[]>(
            CqsOnlineRichiestaSezioneDocumentiViewModel,
            endpoint,
            { idPreventivo }
        );
    }

    public static async requestConcludi(
        idPreventivo: number
    ): Promise<RichiestaConcludiRequestModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.getConcludi;
        return EffectUtility.getToModel<RichiestaConcludiRequestModel>(RichiestaConcludiRequestModel, endpoint, {
            idPreventivo: idPreventivo,
        });
    }

    public static async saveConcludi(
        request: RichiestaConcludiRequestModel
    ): Promise<ResponseEsitoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.saveConcludi;
        return EffectUtility.postToModel<ResponseEsitoModel>(ResponseEsitoModel, endpoint, request);
    }

    public static async requestGetImpegni(idUtente: number): Promise<NuovoImpegnoModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.getImpegni;
        return EffectUtility.getToModel<NuovoImpegnoModel[]>(NuovoImpegnoModel, endpoint, { idUtente: idUtente });
    }

    public static async saveImpegni(
        impegni: NuovoImpegnoModel[]
    ): Promise<ResponseEsitoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.saveImpegni;
        //   console.log("effect " , impegni);
        // debugger;
        let request = [
            ...impegni.map((imp: NuovoImpegnoModel) => ({
                ...imp,
                dataInizio: moment(imp.dataInizio, "DD-MM-YYYY").format("YYYY-MM-DD"), // moment.utc(imp.dataInizio).format("YYYY-MM-DD"),
                //FormatUtility.dateInGivenFormat( imp.dataInizio.replace("-", "/"), "DD/MM/YYYY"),
                dataChiusuraCe:
                    parseInt(imp.dataChiusuraCe.split("/")[1], 10) <= 12
                        ? moment(imp.dataChiusuraCe, "DD-MM-YYYY").format("YYYY-MM-DD")
                        : moment(
                              imp.dataChiusuraCe.split("/")[1] +
                                  "/" +
                                  imp.dataChiusuraCe.split("/")[0] +
                                  "/" +
                                  imp.dataChiusuraCe.split("/")[2],
                              "DD-MM-YYYY"
                          ).format("YYYY-MM-DD"), //moment.utc(imp.dataChiusuraCe).format("YYYY-MM-DD"),
            })),
        ];
        //  debugger;

        return EffectUtility.postToModel<ResponseEsitoModel>(ResponseEsitoModel, endpoint, request);
    }

    public static async deleteDocumentiGeneratiCqsOnline(
        idUtente: number,
        idPreventivo: number
    ): Promise<ResponseEsitoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.deleteDocumentiGeneratiCQSonline;
        return EffectUtility.deleteToModel<ResponseEsitoModel>(ResponseEsitoModel, endpoint, {
            idUtente: idUtente,
            idPreventivo: idPreventivo,
        });
    }

    public static async requestAdeguataVerifica(): Promise<
        RichiestaAdeguataVerificaRequestModel | HttpErrorResponseModel
    > {
        const endpoint: string = environment.api.getAdeguataVerifica;
        return EffectUtility.getToModel<RichiestaAdeguataVerificaRequestModel>(
            RichiestaAdeguataVerificaRequestModel,
            endpoint
        );
    }

    public static async saveAdeguataVerifica(
        request: RichiestaAdeguataVerificaRequestModel
    ): Promise<ResponseEsitoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.saveAdeguataVerifica;
        return EffectUtility.postToModel<ResponseEsitoModel>(ResponseEsitoModel, endpoint, request);
    }

    public static async deleteImpegni(idUtente: number): Promise<ResponseEsitoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.deleteImpegni;
        return EffectUtility.deleteToModel<ResponseEsitoModel>(ResponseEsitoModel, endpoint, { idUtente: idUtente });
    }

    public static async requestTrasferisciDocumentiConsensiCqsWeb(
        idPreventivo: number
    ): Promise<ResponseEsitoModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.trasferisciConsesiCqsWeb;
        console.log("requestTrasferisciDocumentiConsensiCqsWeb idPreventivo " + idPreventivo);
        return EffectUtility.getToModel<ResponseEsitoModel>(ResponseEsitoModel, endpoint, { idPreventivo });
    }

    // #endregion CQS online

    /**
     * This is only to trigger an error api response so we can use it for an example in the AboutPage
     */
    public static async requestError(): Promise<any | HttpErrorResponseModel> {
        const endpoint: string = environment.api.errorExample;
        const response: AxiosResponse | HttpErrorResponseModel = await HttpUtility.get(endpoint);

        if (response instanceof HttpErrorResponseModel) {
            return response;
        }

        return response.data;
    }
}
